import { CircularProgress } from "@mui/material";
import React from "react";

const SmallLoader = () => {
  return (
    <>
      <div className="d-flex justify-content-center">
        <CircularProgress />
      </div>
    </>
  );
};

export default SmallLoader;
